import { memo } from "react";
import type { ComponentProps } from "react";

import { IconButton, Row } from "@narmi/design_system";

import styles from "../../SearchBar.module.scss";

/** Narmi icon name, derived from NDS so it tracks the design system. */
type IconName = ComponentProps<typeof IconButton>["name"];

interface SingleRowProps {
  title: string;
  iconRight: IconName;
  onClickRow: () => void;
  onClickRight?: () => void;
  iconLeft?: string;
}

const SingleRow = ({
  onClickRow,
  title,
  iconRight,
  onClickRight,
  iconLeft,
}: SingleRowProps) => (
  <div onClick={onClickRow}>
    <Row alignItems="center" gapSize="xs">
      {iconLeft && <Row.Item shrink className={`narmi-icon-${iconLeft}`} />}
      <Row.Item className={styles["single-line-text"]}>{title}</Row.Item>
      <Row.Item shrink>
        <IconButton
          name={iconRight}
          textSize="l"
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            onClickRight?.();
          }}
        />
      </Row.Item>
    </Row>
  </div>
);

export default memo(SingleRow);
